// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ffBV","productName":"Table_productName__2IRD3"};